import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer>
      <p>&copy; 2026 techsoul consulting by Christian Sachau</p>
      <p className="footer-links">
        <Link to="/">Website</Link>
        <Link to="/preise">Preise</Link>
        <Link to="/agb">AGB</Link>
        <Link to="/widerruf">Widerruf</Link>
        <Link to="/datenschutz">Datenschutz</Link>
        <Link to="/impressum">Impressum</Link>
      </p>
    </footer>
  );
}

export default Footer;